export const mockupHorario = [
    {name:"Diurno",},
    {name:"Nocturno"}
]